'use client';

import { cn } from '@/lib/utils';

interface TagListProps {
  items: string[];
  /** Tailwind bg/text/border classes for the pill */
  colorClasses?: string;
  className?: string;
}

/** Renders a horizontal list of pills/badges */
export function TagList({ items, colorClasses, className }: TagListProps) {
  if (!items || items.length === 0) return null;
  const colors = colorClasses || 'bg-gray-100 text-gray-700';
  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {items.map((item, i) => (
        <span key={i} className={cn('px-2.5 py-0.5 rounded-full text-xs font-medium', colors)}>
          {item}
        </span>
      ))}
    </div>
  );
}
